import React from 'react';
import { NavLink } from 'react-router-dom';

export default function Navbar() {
  return (
    <nav className="nav">
      <ul>
       
      </ul>
    </nav>
  );
}
